import { useEffect, useState } from "react";

export default function useStyleSheet(href) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.onload = () => setReady(true);
    document.head.appendChild(link);
    return () => link.remove();
  }, [href]);
  return ready;
}